export const freshCxPhone = {
  link: '+16467807957',
  display: '(646)-780-7957',
};
